import React from 'react'
import { Grid, Typography } from '@mui/material';
import '../App.css'
import { Link, useNavigate} from 'react-router-dom';
import {useTitleContext } from '../Context/TitleContext';
import '../App.css'
import { useSwitchForm } from '../Context/SwitchFormContext';


const Navbar = ({ active, state }) => {


    const navigate = useNavigate()

    const { title , setTitle } = useTitleContext();
    const { switchForm } = useSwitchForm();


    const formId = localStorage.getItem("createFormId");

    const navbarData = [
        {
            id: 1,
            title: 'ساختن',
            link: switchForm === 'classic' ? `/build/${formId}` : `/card-form/build/${formId}`
        },
        {
            id: 2,
            title: 'تنظیمات',
            link: `/setting/${formId}`
        },
        {
            id: 3,
            title: 'انتشار',
            link: switchForm === 'classic' ? `/publish/${formId}` : `/card-form/publish/${formId}`
        },
    ];


    const handleChangeHeader = (e) => {
        setTitle(e.target.value)
    }


    const handleNavigate = ()=>{
        navigate('/main')
    }



    return (
        <Grid position={'fixed'} top={0} right={0} zIndex={1000} mb={state ? '0px' : { xs: '0px', xxs: '60px' }} width={'100%'}>
            <Grid p={'10px 20px'} position={'relative'} height={'70px'} bgcolor={'white'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <Grid display={'flex'} position={'absolute'} right={'16px'}>
                    <Grid className='logo positionCenter' width={'50px'} height={'50px'} p={'8px'} bgcolor={'rgb(68, 74, 93)'} display={'flex'} alignItems={'center'} justifyContent={'center'} borderRadius={'4px'} onClick={handleNavigate}>
                        <img src='/assets/images/AltynLogo.svg' alt='' style={{ width: '100%', height: '100%' }} />
                    </Grid>
                </Grid>
                <Grid display={'flex'} alignItems={'center'} justifyContent={'center'} alignContent={'center'} alignSelf={'center'} mx={'auto'} width={'50%'}>
                    <input
                        value={title}
                        onChange={handleChangeHeader}
                        style={{
                            border:'none',
                            outline:'none',
                            fontSize:'24px',
                            fontWeight:700,
                            width:'100%',
                            textAlign:'center',
                        }}
                    />
                </Grid>
            </Grid>
            <Grid width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'} style={{ background: 'linear-gradient(270deg, #ff6100 0%, #ffb841 99.97%)', }} height={'49px'}>
                {
                    navbarData.map(
                        item =>
                            <Link to={item.link} key={item.id}>
                                <Grid py={'13px'} px={'27px'} bgcolor={active === item.id ? 'rgba(255, 255, 255, .25)' : 'transparent'} style={{ cursor: 'pointer' }}
                                    className="navbar-item">
                                    <Typography variant='h4' color={'rgba(255, 255, 255, .75)'} fontWeight={700}>{item.title}</Typography>
                                </Grid>
                            </Link>
                    )
                }
            </Grid>
        </Grid>
    )
}

export default Navbar